// extracted by mini-css-extract-plugin
export default {"fixedWrapper":"GlobalToastWrapper__fixedWrapper___MrAwK","rndWrapper":"GlobalToastWrapper__rndWrapper___WmWic","toastWrapper":"GlobalToastWrapper__toastWrapper___GlI7N"};